// API Configuration
export const API_CONFIG = {
  // Chat Backend API Configuration
  CHAT_API_BASE_URL: process.env.REACT_APP_CHAT_API_URL || 'https://your-backend-domain.com',
  
  // Timeouts
  REQUEST_TIMEOUT: 10000, // 10 seconds
  
  // Rate limits (fallback values)
  DEFAULT_SESSION_LIMIT: 30,
  DEFAULT_DAILY_LIMIT: 80,
  
  // Retry configuration
  MAX_RETRIES: 3,
  RETRY_DELAY: 1000, // 1 second
};

// Environment-specific configurations
export const getApiConfig = () => {
  const isDevelopment = process.env.NODE_ENV === 'development';
  
  return {
    ...API_CONFIG,
    // Override with development settings if needed
    CHAT_API_BASE_URL: isDevelopment 
      ? (process.env.REACT_APP_CHAT_API_URL || API_CONFIG.CHAT_API_BASE_URL)
      : API_CONFIG.CHAT_API_BASE_URL,
  };
}; 